import React, { useEffect, useState } from 'react';
import { useListadoRecordado } from '../../../components/useListadoRecordado';
import axios from '../../../axiosConfig';
import Table from 'react-bootstrap/Table';
import { Modal } from 'react-bootstrap';
import { useParams, useNavigate } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import moment from 'moment';
import { useLoading } from '../../../components/LoadingContext'; 
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import PaginationTable from '../../../components/PaginationTable'; 
import { ResponsiveContainer,Line, LineChart,BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend,AreaChart,Area,Radar,RadarChart, PieChart, Cell, Pie, ComposedChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis } from 'recharts';
import { FaSync,FaSearch } from 'react-icons/fa';  // Importamos íconos de react-icons
import { FaLocationDot } from "react-icons/fa6";


const COLORS = ['#8884d8', '#82ca9d', '#ffc658', '#ff7300', '#00C49F', '#FFBB28'];




const ShowCostoCurso = () => {
    const [costoCurso, setCostoCurso] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const { id } = useParams(); // Obtener el id del curso de la URL
    const [centroOptions, setCentroOptions] = useState([]);
    const [periodoOptions, setPeriodoOptions] = useState([]);
    

    const navigate = useNavigate();
    const { setLoading } = useLoading();
    const userRole = localStorage.getItem('role'); // Obtener el rol del usuario desde el localStorage
    const itemsPerPage = 4; // Número de elementos por página

    const [loadingData, setLoadingData] = useState(false); // Estado para controlar la recarga
    const [range, setRange] = useState(30); // Estado para seleccionar el rango de días
    const [statistics, setStatistics] = useState({});
    const [totalPages, setTotalPages] = useState(1); // Default to 1 page initially


    // Página y filtros se recuerdan: al volver de Editar el listado queda donde estaba.
    // La clave lleva el curso: cada curso recuerda su propia página.
    const { filters, setFilters, currentPage, setCurrentPage } = useListadoRecordado(`costo-curso:${id}`, {
        centro_id: '', 
        cohorte:'',   
        grupo:'',  
        periodo_id:'',
        confirmar:true,

    });
 
    
    const handleShowModal = (id) => {
        setSelectedId(id);  // Almacena el ID del participante que se va a eliminar
        setShowModal(true); // Muestra el modal
    };
    
    const handleCloseModal = () => {
        setShowModal(false); // Cierra el modal
    };   

    useEffect(() => {
    setLoading(true);
    Promise.all([
        getAllCostoCurso(currentPage),
        fetchFilterOptions()
    ]).finally(() => {
        setLoading(false);
    });
}, []);



    const getAllCostoCurso = async (page = 1) => {
        // Buscar pasa el evento del clic como `page`: cualquier cosa que no sea
        // un número es la página 1. Y la página mostrada se fija aquí, así
        // coincide siempre con los datos (buscar, recargar, borrar, paginar).
        const pagina = Number.isInteger(page) && page > 0 ? page : 1;
        setCurrentPage(pagina);
        try {
            let relationsArray = ['periodo','centro','curso'];
             const relations = relationsArray.join(',');
            const token = localStorage.getItem('token');
            const response = await axios.get(`/costo-curso-estadisticas/${id}?with=${relations}`, {
                headers: { Authorization: `Bearer ${token}` },
                params: { ...filters, page: pagina }, // Incluye `page` en los parámetros
            });
            
            const estadisticas = response.data.estadisticas || {};
            
            setCostoCurso(Array.isArray(response.data.datos.data) ? response.data.datos.data : []);
            setStatistics(estadisticas);
            setTotalPages(response.data.datos.last_page || 1); // Actualiza el total de páginas
        } catch (error) {
            console.error('Error fetching data:', error);
            toast.error('Error fetching data');
            setCostoCurso([]);
            setStatistics({});
        }
    };

    

      const fetchFilterOptions = async () => {
            try {
                const token = localStorage.getItem('token');
                const response = await axios.get(`/filtros-cursos`, { headers: { Authorization: `Bearer ${token}` } });
                
                setCentroOptions(response.data.centro);
                setPeriodoOptions(response.data.periodo);
              
    
    
        
            } catch (error) {
                console.error('Error fetching filter options:', error);
            }
        };
    
    const deleteCostoCurso = async () => {
            try {
                const token = localStorage.getItem('token');
                await axios.delete(`/costo-curso/${selectedId}`,{
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                getAllCostoCurso();
                setShowModal(false); // Cierra el modal tras la eliminación exitosa
                toast.success('Costo Curso eliminado con éxito');
            } catch (error) {
                // setError('Error deleting data');
                console.error('Error deleting data:', error);
                toast.error('Error al eliminar el Costo Curso');
            }
        
    };
 
  
    const loadData = async () => {
        setLoadingData(true); // Inicia el estado de carga
        try {
            await (getAllCostoCurso(),fetchFilterOptions()); // Espera a que getAllDatos haga la solicitud y actualice los datos
        } catch (error) {
            console.error('Error recargando los datos:', error); // Maneja el error si ocurre
        } finally {
            setLoadingData(false); // Detener el estado de carga cuando la solicitud haya terminado
        }
    };

    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilters(prev => ({ ...prev, [name]: value }));
    };
 
    const handlePageChange = (page) => {
        setCurrentPage(page);
        getAllCostoCurso(page); // Llama a `getAllDatos` con el nuevo número de página
        
    };

    const totalCostoCurso = statistics.totalCostoCurso || 0;


    const columns = ["Cohorte","Periodo", "Centro","Grupo","Costo Insc", "Costo Cuota","Costo Total","Número de Cuotas","Periodicidad"];

    const renderItem = (costoCurso) => (
        <tr key={costoCurso.id}>
        <td >{costoCurso?.cohorte}</td>

        <td >{costoCurso?.periodo.descripcion}</td>
        <td >{costoCurso?.centro.descripcion}</td>
        <td >{costoCurso.grupo}</td>
        <td >{costoCurso.costo_insc}</td>
        <td >{costoCurso.costo_cuota}</td>
         <td >{costoCurso.total}</td>
        <td >{costoCurso.num_cuotas}</td>
        <td >{costoCurso.periodicidad}</td>
       
       
       
        <td >
            <div className="d-flex justify-content-around">

                <Button
                    variant="btn btn-warning" 
                    onClick={() => navigate(`/costo-curso/${costoCurso.id}/edit`)}
                    className="me-2"
                    title='Editar'
                >
                    <i className="bi bi-pencil-fill"></i>
                </Button>
                {userRole === 'admin' && (
                

                <Button
                variant="btn btn-danger"
                onClick={() => handleShowModal(costoCurso.id)}
                className="me-2"
                title='Eliminar'
                >
                <i className="bi bi-trash3-fill"></i>
                </Button>
                )}
            </div>
        </td>
        </tr>
    );

    return (
        <div className="container-fluid mt-2" style={{ fontSize: '0.85rem' }}>
            <div className="col-lg-11 mx-auto d-flex justify-content-center"> 
                <div className="stat-box d-flex justify-content-center align-items-center" style={{ maxWidth: '100%' }}>
                    {/* Total de costoCurso */}
                    <div className="stat-card text-center" style={{ padding: '5px', width: '100%' }}>
                        <div className="stat-icon"><FaLocationDot /></div>
                        <div className="stat-number" style={{ color: '#58c765', fontSize: '1.2rem' }}>{totalCostoCurso}</div>
                        <div className="stat-label">Total de Costo Curso </div>
                    </div>
                </div>
            </div>




            <div className="row" style={{ marginTop: '10px' }}>
                {/* Columna para la tabla */}
                <div className="col-lg-11 mx-auto"> {/* Agregamos 'mx-auto' para centrar */}
                    <div className="card-box" style={{ padding: '20px', width: '100%', margin: '0 auto' }}> 
                    <div className="d-flex justify-content-between align-items-center mb-3" style={{ gap: '0px' }}>
                        <h2>Lista de Costo Curso {costoCurso[0]?.curso?.cod ?? '...'}</h2>
                        <div className="d-flex align-items-center">
                            
                            <Button
                                variant="info me-2"
                                onClick={loadData}
                                disabled={loadingData} // Deshabilita el botón si está cargando
                                style={{ padding: '5px 10px', width: '90px' }} // Ajusta padding y ancho
                                title='Recargar datos'

                                >
                                {/* Icono de recarga */}
                                {loadingData ? (
                                    <FaSync className="spin" /> // Ícono girando si está cargando
                                ) : (
                                    <FaSync />
                                )}
                            </Button>
                            <Button 
                                    variant="info me-2" 
                                    onClick={getAllCostoCurso}
                                    style={{ padding: '5px 10px', width: '120px' }} // Ajusta padding y ancho
                                    title='Buscar'
                                >
                                    <FaSearch className="me-1" /> {/* Ícono de lupa */}
                                </Button>
                            {userRole === 'admin' ||userRole === 'pagos' ? (

                            <Button variant="btn custom" onClick={() => navigate(`/costo-curso/${id}/create`)} className="btn-custom" title='Crear CostoCurso'>
                            <i className="bi bi-coin me-2  "></i> Nuevo
                            </Button>
                            ):null}
                        </div>
                    </div>
                    <div className="d-flex mb-3">

                        <Form.Select
                                name="centro_id"
                            value={filters.centro_id}
                            onChange={handleFilterChange}
                            className="me-2"
                            style={{ fontSize: '0.9rem' }}
                            >
                            <option value="">Filtrar por Centro</option>
                            {centroOptions.map(option => (
                                <option key={option.id} value={option.id}>{option.descripcion}</option>
                            ))}
                        </Form.Select>
                   <Form.Control
                  name="cohorte"
                  type="text"
                  placeholder="Buscar por cohorte"
                  value={filters.cohorte}
                  onChange={handleFilterChange}
                  className="me-2"
                  style={{ fontSize: '0.9rem' }}
                  
                />
                <Form.Control
                  name="grupo"
                  type="text"
                  placeholder="Buscar por Grupo"
                  value={filters.grupo}
                  onChange={handleFilterChange}
                  className="me-2"
                  style={{ fontSize: '0.9rem' }}
                  
                />
               
                <Form.Select
                  name="periodo_id"
                  value={filters.periodo_id}
                  onChange={handleFilterChange}
                  className="me-2"
                  style={{ fontSize: '0.9rem' }}
                >
                  <option value="">Filtrar por Periodo</option>
                  {periodoOptions.map(option => (
                    <option key={option.id} value={option.id}>{option.descripcion}</option>
                  ))}
                </Form.Select>

                
                

                

               

              </div>
                    {/* Tabla paginada */}
                    
                        <PaginationTable
                            data={costoCurso}
                            itemsPerPage={itemsPerPage}
                            columns={columns}
                            renderItem={renderItem}
                            currentPage={currentPage}
                            onPageChange={handlePageChange}
                            totalPages={totalPages}  
                        />


                    {/* Modal  de eliminación */}
                    <Modal show={showModal} onHide={handleCloseModal}>
                        <Modal.Header closeButton>
                            <Modal.Title>Confirmar eliminación</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>¿Estás seguro de que deseas eliminar esta Costo Curso?</Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleCloseModal}>
                                Cancelar
                    </Button>
                    <Button variant="danger" onClick={deleteCostoCurso}>
                        Eliminar
                    </Button>
                </Modal.Footer>
            </Modal>
            <ToastContainer />
        </div>
        
        </div>
        </div>
        </div>
    );
};

export default ShowCostoCurso;
